/// <amd-module name="VSSUI/Splitter" />
export * from "./Components/Splitter/index";
